(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hiverane-external-reviews"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('hiverane-review-list')) {
    customElements.define('hiverane-review-list', class extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        const cards = [...this.querySelectorAll('.her-card')];
        const button = this.querySelector('.her-more');
        const pagination = this.querySelector('.her-pagination');
        const progress = this.querySelector('.her-progress');
        if (!cards.length || !button || !pagination || !progress) return;
        this.initialized = true;
        this.dataset.enhanced = 'true';
        const measure = () => {
          cards.filter(card => !card.hidden).forEach(card => {
            const quote = card.querySelector('blockquote');
            const toggle = card.querySelector('[data-review-toggle]');
            if (!quote || !toggle) return;
            const expanded = card.dataset.expanded === 'true';
            toggle.hidden = !expanded && quote.scrollHeight <= quote.clientHeight + 1;
            toggle.textContent = expanded ? this.dataset.collapse : this.dataset.expand;
            toggle.setAttribute('aria-expanded', String(expanded));
            toggle.setAttribute('aria-label', (expanded ? this.dataset.collapseLabel : this.dataset.expandLabel).replace('__author__', card.querySelector('.her-author strong').textContent));
          });
        };
        cards.forEach(card => {
          card.querySelector('[data-review-toggle]')?.addEventListener('click', () => {
            card.dataset.expanded = String(card.dataset.expanded !== 'true');
            measure();
          });
        });
        this.resizeObserver = new ResizeObserver(entries => {
          const width = entries[0]?.contentRect.width;
          if (this.lastWidth === width) return;
          this.lastWidth = width;
          measure();
        });
        this.resizeObserver.observe(this);
        document.fonts.ready.then(measure);
        const update = () => {
          const count = cards.filter(card => !card.hidden).length;
          progress.textContent = this.dataset.progressTemplate.replace('__shown__', String(count));
          button.hidden = count >= cards.length;
          measure();
        };
        pagination.hidden = false;
        update();
        button.addEventListener('click', () => {
          const next = cards.filter(card => card.hidden).slice(0, 10);
          next.forEach(card => { card.hidden = false; });
          update();
          next[0]?.focus({preventScroll: true});
        });
      }
      disconnectedCallback() { this.resizeObserver?.disconnect(); }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hiverane-product-detail"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('.hpd-purchase-panel form').forEach(form => {
  const choices = Array.from(form.querySelectorAll('input[type="radio"][name="id"]'));
  const selected = choices.find(choice => choice.checked);
  if (!selected) return;
  const variantId = document.createElement('input');
  variantId.type = 'hidden';
  variantId.name = 'id';
  variantId.value = selected.value;
  choices.forEach(choice => { choice.name = 'hiverane_variant'; });
  form.prepend(variantId);
  const breakdown = form.querySelector('[data-delivered-breakdown]');
  const singleBreakdown = breakdown ? breakdown.dataset.singleStandard : '';
  const promoBreakdown = breakdown ? breakdown.dataset.singlePromo : '';
  const money = new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'EUR' });
  const updateOffer = () => {
    const choice = choices.find(item => item.checked);
    const quantityChoice = form.querySelector('input[name="quantity"]:checked');
    const quantity = quantityChoice ? Number(quantityChoice.value) : 1;
    const unit = Number(choice.dataset.unitCents);
    const freeShipping = document.documentElement.dataset.shippingPromo === 'true';
    const discount = quantity >= 3 ? 4580 : (quantity === 2 ? 1790 : 0);
    const total = unit * quantity - discount;
    const delivered = form.querySelector('[data-delivered-price]');
    if (delivered) delivered.textContent = money.format(total / 100);
    if (breakdown) breakdown.textContent = quantity === 1 ? (freeShipping ? promoBreakdown : singleBreakdown) : form.querySelector(quantity === 2 ? '[data-breakdown-duo]' : '[data-breakdown-trio]').textContent;
  };
  document.addEventListener('hiverane:shipping-promo', updateOffer);
  updateOffer();
  form.querySelectorAll('input[name="quantity"]').forEach(input => input.addEventListener('change', updateOffer));
  form.addEventListener('change', event => {
    if (!event.target.matches('input[name="hiverane_variant"]')) return;
    variantId.value = event.target.value;
    variantId.dispatchEvent(new Event('change', { bubbles: true }));
    const price = document.getElementById('variant-price');
    if (price) price.textContent = event.target.dataset.price;
    updateOffer();
    const stickyPrice = document.querySelector('[data-sticky-price]');
    if (stickyPrice) stickyPrice.textContent = event.target.dataset.price;
    const stickyVariant = document.querySelector('[data-sticky-variant]');
    if (stickyVariant) stickyVariant.textContent = event.target.closest('label').querySelector('span').firstChild.textContent.trim();
    const stickyButton = document.querySelector('.hpd-sticky-add');
    if (stickyButton) stickyButton.disabled = event.target.disabled;
    const button = form.querySelector('.hpd-add');
    if (button && button.dataset.salesEnabled === 'true') {
      button.disabled = event.target.disabled;
      const label = button.querySelector('[data-add-label]');
      if (label) label.textContent = button.disabled ? button.dataset.labelUnavailable : button.dataset.labelAvailable;
    }
  });
});
const stickyBar = document.querySelector('.hpd-sticky');
const purchaseButton = document.querySelector('.hpd-add');
if (stickyBar && purchaseButton) {
  let stickyFrame = 0;
  const syncSticky = () => { stickyBar.hidden = purchaseButton.getBoundingClientRect().bottom > 0; };
  const scheduleSticky = () => {
    cancelAnimationFrame(stickyFrame);
    stickyFrame = requestAnimationFrame(syncSticky);
  };
  new IntersectionObserver(syncSticky, {threshold: 0}).observe(purchaseButton);
  window.addEventListener('scroll', scheduleSticky, {passive: true});
  window.addEventListener('resize', scheduleSticky, {passive: true});
  syncSticky();
}
if (!customElements.get('hiverane-product-gallery')) {
  customElements.define('hiverane-product-gallery', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      const track = this.querySelector('.hpd-track');
      const slides = Array.from(this.querySelectorAll('.hpd-slide'));
      const thumbs = Array.from(this.querySelectorAll('[data-gallery-index]'));
      const previous = this.querySelector('[data-gallery-prev]');
      const next = this.querySelector('[data-gallery-next]');
      const count = this.querySelector('[data-gallery-count]');
      const dialog = this.querySelector('dialog');
      let active = 0;
      let frame = 0;
      const update = () => {
        active = Math.max(0, Math.min(slides.length - 1, Math.round(track.scrollLeft / track.clientWidth)));
        thumbs.forEach((button, index) => button.setAttribute('aria-pressed', String(index === active)));
        previous.disabled = active === 0;
        next.disabled = active === slides.length - 1;
        count.textContent = String(active + 1).padStart(2, '0') + ' / ' + String(slides.length).padStart(2, '0');
      };
      const go = index => track.scrollTo({left: Math.max(0, Math.min(slides.length - 1, index)) * track.clientWidth, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
      track.addEventListener('scroll', () => { cancelAnimationFrame(frame); frame = requestAnimationFrame(update); }, {passive: true});
      thumbs.forEach((button, index) => button.addEventListener('click', () => go(index)));
      previous.addEventListener('click', () => go(active - 1));
      next.addEventListener('click', () => go(active + 1));
      track.addEventListener('keydown', event => {
        if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); go(active + (event.key === 'ArrowRight' ? 1 : -1)); }
        if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); go(event.key === 'Home' ? 0 : slides.length - 1); }
      });
      this.querySelectorAll('[data-zoom-src]').forEach(button => button.addEventListener('click', () => {
        const image = this.querySelector('[data-zoom-image]');
        image.src = button.dataset.zoomSrc;
        image.alt = button.querySelector('img').alt;
        this.querySelector('[data-zoom-caption]').textContent = button.closest('.hpd-slide').dataset.caption;
        dialog.showModal();
      }));
      this.querySelector('[data-zoom-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      update();
    }
  });
}

  } catch(e) { console.error(e); }
})();
})();
